(() => {
  const eligibleButtonSelector = 'button[data-timesact-preorder-eligible][disabled]';
  const preorderMarkerSelector = '[data-timesact-selling-plan], #preorder-label';

  const enableTimesactPreorderButtons = () => {
    document.querySelectorAll('form[data-product-form]').forEach((form) => {
      if (!form.querySelector(preorderMarkerSelector)) return;

      form.querySelectorAll(eligibleButtonSelector).forEach((button) => {
        button.disabled = false;
        button.removeAttribute('disabled');
      });
    });
  };

  let queued = false;
  const scheduleUpdate = () => {
    if (queued) return;

    queued = true;
    queueMicrotask(() => {
      queued = false;
      enableTimesactPreorderButtons();
    });
  };

  enableTimesactPreorderButtons();
  new MutationObserver(scheduleUpdate).observe(document.body, { childList: true, subtree: true });
})();
